import script from "./NhapXuatTonKhoPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./NhapXuatTonKhoPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./NhapXuatTonKhoPrintTemplate.vue?vue&type=style&index=0&id=e31717d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e31717d0"]])

export default __exports__